import LayoutPage from "../../Components/LayoutPage";
import CalculatorPanel from "./CalculatorPanel";

export default function Calculator() {
  return (
    <LayoutPage activeIndex={5} navItems={["ماشین حساب"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5">
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        <CalculatorPanel />
      </div>
    </LayoutPage>
  )
}
